import Yggdrasil from 'services/yggdrasil'
import i18n from 'services/i18n'

const state = {
    listItemType: 'Courses',
    selectedCategories: [],
    selectedRibbon: null,
    selectedLevel: null,
    selectedInstructor: null,
    selectAuthorization: null,
    selectedAuthorization: null,
    selectedCourseType: null,
    selectedSubjectAreas: [],
    selectedContentType: null,
    ribbonOptions: [
        { label: 'Ribbon.new', color: 'new' },
        { label: 'Ribbon.coming', color: 'upcoming' },
        { label: 'Ribbon.expiring', color: 'expiring' },
        { label: 'Ribbon.favourite', color: 'favourite' },
        { label: 'Ribbon.topical', color: 'topical' },
        { label: 'Ribbon.customer', color: 'customer' },
        { label: 'General.free', color: 'free' },
    ],
    categories: [],
    selectedSorting: null,
    currentPackageSlug: null,
    searchPhrase: null,
    completedCheckbox: null,
    showMoreFilters: true,
}

const mutations = {
    ASSIGN_LIST_ITEM_TYPE (state, option) {
        state.listItemType = option
    },
    SELECT_LEVEL (state, option) {
        state.selectedLevel = option
    },
    SELECT_INSTRUCTOR (state, option) {
        state.selectedInstructor = option
    },
    SELECT_SORTING (state, option) {
        state.selectedSorting = option
    },
    SELECT_AUTHORIZATION (state, option) {
        state.selectedAuthorization = option
    },
    SELECT_COURSE_TYPE (state, option) {
        state.selectedCourseType = option
    },
    SELECT_CONTENT_TYPE (state, option) {
        state.selectedContentType = option
    },
    ASSIGN_COURSES_CATEGORIES (state, categories) {
        state.categories = categories
    },
    ADD_SELECTED_OPTION (state, option) {
        if (!(state.selectedCategories.find(localOption => localOption.id === option.id))) {
            state.selectedCategories.push(option)
        }
    },
    ADD_SELECTED_SUBJECT_AREA (state, option) {
        if (!(state.selectedSubjectAreas.find(localOption => localOption.id === option.id))) {
            state.selectedSubjectAreas.push(option)
        }
    },
    CLEAR_SELECTED_OPTIONS (state) {
        state.selectedCategories = []
    },
    REMOVE_SELECTED_OPTION (state, option) {
        state.selectedCategories = state.selectedCategories.filter(el => +el.id !== +option.id)
    },
    REMOVE_SELECTED_SUBJECT_AREA (state, option) {
        state.selectedSubjectAreas = state.selectedSubjectAreas.filter(el => el.id !== option.id)
    },
    REMOVE_ALL_CATEGORIES_OPTIONS (state) {
        state.selectedCategories = []
    },
    REMOVE_ALL_SUBJECT_AREAS (state) {
        state.selectedSubjectAreas = []
    },
    ADD_SELECTED_RIBBON (state, option) {
        state.selectedRibbon = option
    },
    CLEAR_SELECTED_RIBBON (state) {
        state.selectedRibbon = null
    },
    CLEAR_SELECTED_COURSE_TYPE (state) {
        state.selectedCourseType = null
    },
    CLEAR_SELECTED_CONTENT_TYPE (state) {
        state.selectedContentType = null
    },
    ASSIGN_CURRENT_PACKAGE_SLUG (state, packageSlug) {
        state.currentPackageSlug = packageSlug
    },
    ASSIGN_SEARCH_PHRASE (state, searchPhrase) {
        state.searchPhrase = searchPhrase
    },
    ASSIGN_COMPLETED_CHECKBOX (state, completedCheckbox) {
        state.completedCheckbox = completedCheckbox
    },
    ASSIGN_SHOW_MORE_FILTERS (state, value) {
        state.showMoreFilters = value
    }
}

const actions = {
    assignListItemType (store, type) {
        store.commit('ASSIGN_LIST_ITEM_TYPE', type)
    },
    async loadCategories (store) {
        const categories = await Yggdrasil.loadCategories()
        store.commit('ASSIGN_COURSES_CATEGORIES', categories)
    },
    addSelectedOption (store, option) {
        if (option === null) {
            store.commit('CLEAR_SELECTED_OPTIONS', option)
            return
        }
        store.commit('ADD_SELECTED_OPTION', option)
    },
    addSelectedSubjectArea (store, option) {
        if (option === null) {
            store.commit('CLEAR_SELECTED_OPTIONS', option)
            return
        }
        store.commit('ADD_SELECTED_SUBJECT_AREA', option)
    },
    removeSelectedOption (store, option) {
        store.commit('REMOVE_SELECTED_OPTION', option)
    },
    removeSelectedSubjectArea (store, option) {
        store.commit('REMOVE_SELECTED_SUBJECT_AREA', option)
    },
    removeAllCategoriesOptions (store) {
        store.commit('REMOVE_ALL_CATEGORIES_OPTIONS')
    },
    removeAllSubjectAreas (store) {
        store.commit('REMOVE_ALL_SUBJECT_AREAS')
    },
    addSelectedRibbon (store, option) {
        if (option === null) {
            store.commit('CLEAR_SELECTED_RIBBON', option)
            return
        }
        store.commit('ADD_SELECTED_RIBBON', option)
    },
    selectAuthorization (store, option) {
        store.commit('SELECT_AUTHORIZATION', option)
    },
    selectLevel (store, option) {
        store.commit('SELECT_LEVEL', option)
    },
    selectInstructor (store, option) {
        store.commit('SELECT_INSTRUCTOR', option)
    },
    selectCourseType (store, option) {
        store.commit('SELECT_COURSE_TYPE', option)
    },
    selectContentType (store, option) {
        store.commit('SELECT_CONTENT_TYPE', option)
    },
    selectSorting (store, option) {
        store.commit('SELECT_SORTING', option)
    },
    clearSelectedRibbon (store) {
        store.commit('CLEAR_SELECTED_RIBBON')
    },
    clearSelectedCourseType (store) {
        store.commit('CLEAR_SELECTED_COURSE_TYPE')
    },
    clearSelectedContentType (store) {
        store.commit('CLEAR_SELECTED_CONTENT_TYPE')
    },
    clearFilter (store) {
        store.commit('SELECT_LEVEL', null)
        store.commit('SELECT_AUTHORIZATION', null)
        store.commit('SELECT_INSTRUCTOR', null)
        store.commit('SELECT_CONTENT_TYPE', null)
        store.commit('CLEAR_SELECTED_OPTIONS')
        store.commit('CLEAR_SELECTED_RIBBON')
        store.commit('CLEAR_SELECTED_COURSE_TYPE')
        store.commit('SELECT_SORTING', null)
        store.commit('ASSIGN_SEARCH_PHRASE', null)
        store.commit('ASSIGN_COMPLETED_CHECKBOX', null)
    },
    assignCurrentPackageSlug (store, packageSlug) {
        store.commit('ASSIGN_CURRENT_PACKAGE_SLUG', packageSlug)
    },
    assignSearchPhrase (store, searchPhrase) {
        store.commit('ASSIGN_SEARCH_PHRASE', searchPhrase)
    },
    assignCompletedCheckbox (store, completedCheckbox) {
        store.commit('ASSIGN_COMPLETED_CHECKBOX', completedCheckbox)
    },
    showMoreFilters (store, value) {
        store.commit('ASSIGN_SHOW_MORE_FILTERS', value)
    }
}

function filterTreeByCategories (tree, categories) {
    return tree.filter(leaf => categories.find(cat => +cat.id === +leaf.id)).map(leaf => {
        if (leaf.children) {
            return {
                ...leaf,
                children: filterTreeByCategories(leaf.children, categories)
            }
        } else {
            return leaf
        }
    })
}

const getters = {
    getListItemType: (state, getters) => state.listItemType,
    getFilteredCategories: (state, getters) => (filterBy) => {
        let categories = getters.getCategories.slice()
        let filterByCategories = filterBy.slice()
        return filterTreeByCategories(categories, filterByCategories)
    },
    getSelectedLevel: state => state.selectedLevel,
    getSelectedInstructor: state => state.selectedInstructor,
    getSelectedAuthorization: state => state.selectedAuthorization,
    getSelectedCategories: state => state.selectedCategories,
    getSelectedSubjectAreas: state => state.selectedSubjectAreas,
    getSelectedCourseType: state => state.selectedCourseType,
    getSelectedContentType: state => state.selectedContentType,
    getSelectedRibbon: (state) => state.selectedRibbon,
    getSelectedSorting: state => state.selectedSorting,
    getRibbonOptions: (state) => state.ribbonOptions,
    getSearchPhrase: (state) => state.searchPhrase,
    getCategories: (state) => {
        if (state.categories.length === 1) {
            return state.categories[0].children // We force category as a root if there is only one of them
        }
        return state.categories
    },

    getNameOfCategoryByIdInTree: (state, getters) => (tree, id) => {
        let leaf = tree.find(leaf => +leaf.id === +id)
        if (leaf) {
            return leaf.label
        }
        let obj = tree.find(leaf => {
            if (leaf.children) {
                return getters.getNameOfCategoryByIdInTree(leaf.children, id)
            }
            return false
        })
        if (obj) {
            return getters.getNameOfCategoryByIdInTree(obj.children, id)
        }
        return null
    },

    getIdOfCategoryByLabelInTree: (state, getters) => (tree, label) => {
        let leaf = tree.find(leaf => leaf.label === label)
        if (leaf) {
            return leaf.id
        }

        let obj = tree.find(leaf => {
            if (leaf.children) {
                return getters.getIdOfCategoryByLabelInTree(leaf.children, label)
            }
            return false
        })

        if (obj) {
            return getters.getIdOfCategoryByLabelInTree(obj.children, label)
        }
        return null
    },
    getCurrentPackageSlug: (state) => state.currentPackageSlug,
    getCompletedCheckbox: (state) => state.completedCheckbox,
    getShowMoreFilterState: (state) => state.showMoreFilters,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
